export const LIISA_API_URL = process.env["REACT_APP_LIISA_API_URL"];
export const LIISA_MOCK_API_URL = process.env["REACT_APP_LIISA_MOCK_API_URL"];
